const PitchView = ({ lineup = [], formation }) => {
  const parts = (formation || "").split("-").map((n) => parseInt(n, 10));
  const valid =
    parts.length > 0 &&
    parts.every((n) => Number.isFinite(n) && n > 0) &&
    parts.reduce((a, b) => a + b, 0) === 10 &&
    lineup.length === 11;
  if (!valid) return null;

  const players = [];
  let idx = 1;
  const rowCount = parts.length;
  parts.forEach((count, r) => {
    const y = rowCount === 1 ? 50 : 24 + r * (64 / (rowCount - 1));
    for (let i = 0; i < count; i++) {
      const x = count === 1 ? 50 : 14 + i * (72 / (count - 1));
      players.push({ name: lineup[idx], number: idx + 1, x, y });
      idx++;
    }
  });

  const Marker = ({ p }) => (
    <div
      className="absolute z-10 flex w-14 flex-col items-center gap-1 sm:w-20"
      style={{ left: `${p.x}%`, bottom: `${p.y}%`, transform: "translate(-50%, 50%)" }}
      data-testid={`pitch-player-${p.number}`}
    >
      <span className="flex h-9 w-9 items-center justify-center rounded-full border-2 border-white/80 bg-crimson font-mono-score text-sm font-bold text-white shadow-lg sm:h-10 sm:w-10">
        {p.number}
      </span>
      <span className="max-w-full truncate rounded-md bg-ink/85 px-1.5 py-0.5 text-center font-display text-[10px] font-bold uppercase leading-tight text-white backdrop-blur-sm sm:text-xs">
        {p.name}
      </span>
    </div>
  );

  return (
    <div
      className="relative mx-auto mb-8 w-full max-w-md overflow-hidden rounded-2xl border border-white/10"
      style={{ aspectRatio: "3/4" }}
      data-testid="pitch-view"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-[#15803d] to-[#14532d]" />
      <div
        className="absolute inset-0 opacity-30"
        style={{ background: "repeating-linear-gradient(180deg, transparent 0 7%, rgba(255,255,255,0.07) 7% 14%)" }}
      />
      <div className="absolute inset-3 rounded-md border-2 border-white/40" />
      <div className="absolute left-3 right-3 top-1/2 h-0.5 -translate-y-1/2 bg-white/40" />
      <div className="absolute left-1/2 top-1/2 h-24 w-24 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white/40" />
      <div className="absolute left-1/2 top-1/2 h-1.5 w-1.5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white/60" />
      <div className="absolute left-1/2 top-3 h-16 w-[46%] -translate-x-1/2 border-2 border-t-0 border-white/40" />
      <div className="absolute left-1/2 top-3 h-7 w-[24%] -translate-x-1/2 border-2 border-t-0 border-white/40" />
      <div className="absolute bottom-3 left-1/2 h-16 w-[46%] -translate-x-1/2 border-2 border-b-0 border-white/40" />
      <div className="absolute bottom-3 left-1/2 h-7 w-[24%] -translate-x-1/2 border-2 border-b-0 border-white/40" />

      <Marker p={{ name: lineup[0], number: 1, x: 50, y: 7 }} />
      {players.map((p) => (
        <Marker key={p.number} p={p} />
      ))}

      <span className="absolute right-4 top-4 z-10 rounded-full bg-ink/85 px-3 py-1 font-mono-score text-xs font-bold text-white backdrop-blur-sm" data-testid="pitch-formation">
        {formation}
      </span>
      <span className="absolute bottom-4 left-4 z-10 font-mono-score text-[9px] uppercase tracking-[0.25em] text-white/70">
        El Molinón
      </span>
    </div>
  );
};

export default PitchView;
